var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSwitch } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { customFieldsApi } from 'apis/customFields';
import { analytics } from 'app/utils/segment';
import { useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** Represents the a toggle to activate/deactivate a custom attribute. */
export const ActiveToggle = ({ attribute, onChange, }) => {
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const { id: attributeId, entity_id: entityId, is_deactivated, type, } = attribute;
    const isDeactivating = !is_deactivated;
    /** Handles deleting custom attribute. */
    const handleToggle = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        onChange === null || onChange === void 0 ? void 0 : onChange(isDeactivating);
        const response = yield dispatch(customFieldsApi.endpoints.updateAttribute.initiate({
            attributeId,
            entityId,
            patch: {
                before: attribute,
                after: Object.assign(Object.assign({}, attribute), { is_deactivated: isDeactivating }),
            },
        }));
        if (!isResponseWithData(response)) {
            notify({
                title: isDeactivating
                    ? 'Could not activate custom attribute'
                    : 'Could not deactivate custom attribute',
                text: isDeactivating
                    ? 'An error occurred while trying to activate a custom attribute'
                    : 'An error occurred while trying to deactivate a custom attribute',
                type: 'error',
                icon: 'exclamation',
                status: 'danger',
            });
        }
        if (isDeactivating) {
            analytics.settingsCustomAttributeDeactivated({
                attributeId,
                entityId,
                type,
            });
        }
        else {
            analytics.settingsCustomAttributeActivated({
                attributeId,
                entityId,
                type,
            });
        }
    }), [
        attribute,
        attributeId,
        dispatch,
        entityId,
        isDeactivating,
        notify,
        onChange,
        type,
    ]);
    return (_jsx(FieldSwitch, { input: {
            name: 'active',
            value: 'active',
            checked: isDeactivating,
            onChange: handleToggle,
        } }));
};
